<template>
  <el-form label-width="180px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="名称" required>
      <el-input v-model="form.title" />
    </el-form-item>
    <!-- <el-form-item label="全部人数" required>
      <el-input v-model="form.lv0" />
    </el-form-item> -->
    <el-form-item label="直推人数" required>
      <el-input v-model="form.lv1" />
    </el-form-item>
    <el-form-item label="间推人数" required>
      <el-input v-model="form.lv2" />
    </el-form-item>
    <el-form-item label="固定工资" required>
      <el-input v-model="form.amount" />
    </el-form-item>
    <el-form-item label="会员等级" required>
      <!-- <el-input v-model="form.level_id" /> -->
      <el-select v-model="form.level_id" placeholder="会员等级">
        <el-option v-for="item in levelTypeEnums" :label="item.title" :value="item.id" :key="item.id" />
      </el-select>
    </el-form-item>
    <el-form-item label="团队等级" required>
      <!-- <el-input v-model="form.level_id" /> -->
      <el-select v-model="form.team_id" placeholder="团队等级">
        <el-option v-for="item in teamLevelTypeEnums" :label="item.title" :value="item.id" :key="item.id" />
      </el-select>
    </el-form-item>
    <el-form-item label="签到金额" required>
      <el-input v-model="form.sign_amount" />
    </el-form-item>
    <el-form-item label="团队盈利" required>
      <el-input v-model="form.profit" />
    </el-form-item>
    <el-form-item label="盈利奖励（%）" required>
      <el-input v-model="form.profit_rate" />
    </el-form-item>
  </el-form>
</template>

<script setup>
  import teamLevelListHook from '@/hooks/teamLevelListHook'
  import userLevelListHook from '@/hooks/userLevelListHook'
  import { nextTick, onMounted, ref } from 'vue'

  const form = ref({
    title: '',
    lv2: '',
    lv1: '',
    profit: '',
    profit_rate: '',
    level_id: 0,
    amount: '',
    sign_amount: '',
    team_id: 0,
  })
  const props = defineProps(['item'])

  const { levelTypeEnums } = userLevelListHook()
  const { teamLevelTypeEnums } = teamLevelListHook()

  onMounted(() => {
    nextTick(() => {
      form.value = Object.assign(form, props.item)
    })
  })

  defineExpose({ form })
</script>

<style lang="less" scoped>
  .demo-form-inline {
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
  }

  .demo-form-inline .el-input {
    --el-input-width: 220px;
  }

  .demo-form-inline .el-select {
    --el-select-width: 220px;
  }

  /deep/ .el-radio-group {
    width: 220px;
  }

  .form-title {
    text-align: left;
    padding-left: 30px;
    margin: 20px auto 10px;
    height: 44px;
    background-color: #f2f2f2;
    border-radius: 5px;
    line-height: 44px;
    width: 100%;
  }

  /deep/ .el-form-item {
    align-items: flex-start;
  }
</style>
